module.exports = __webpack_public_path__ + "c73a30dec0555353923920e1d0e5ee35.png";